export default {
  //代码里的key(唯一标识): '英语',
  lang: 'en',
  appIntroduction: 'Popular Movies & Dramas are free to watch at any time',
  noMoreTip: 'This is the bottom, there is no more content~',
  navigator: {
    home: 'Home',
    all: 'All contents',
    news: 'News',
    download: 'Download APP',
    contact: 'About Us',
    joinUs: 'Join us'
  },
  seo: {
    title: 'Loklok Watch HD movies online for free',
    keywords: 'Loklok, Loklok app, loklok tv, Loklok official website,Watch online, Watch for Free, Watch dramas for free,Loklok web,Loklok movie, new movies,tv show,Snowdrop,Hotel Transylvania,Encanto,The Silent Sea,Jujutsu Kaisen,9-1-1: Lone Star,Hotel Transylvania,Dragons,SnowdropOur Beloved SummerDemon SlayerHappinessSing 2Ranking of KingsDemon SlayerAttack on TitanTrue BeautyVincenzoAttack on Titan The Final SeasonJujutsu KaisenThe HandmaidenTokyo RevengersNeverthelessItaewon ClassSquid GameCrash Landing on YouEuphoriaAttack on TitanHometown Cha-Cha-Cha',
    description: 'Popular episodes updated quickly,American hot seriesTension, comedy, thriller,Newest hottest dramasall in Loklok',
    ogImage: 'https://static.loklok.video/img/tw-en.png',
    downloadPageKeywords: 'Loklok download, Loklok app, lokok download,Loklok ios,Loklok latest,Watch online, Watch for Free, Watch dramas for free, Loklok pc, Loklok for pc, Loklok download pc, Loklok pc download, download Loklok pc, use Loklok on pc, Loklok latest version, how to use Loklok on pc, Loklok Official website',
    index: {
      title: 'Loklok - Watch HD movies online for free - Highest Rated Movies Recommendation',
      keywords: 'Loklok, Loklok app, loklok download, download loklok, loklok pc, loklok apk,Watch online, Watch for Free, Watch dramas for free, loklok ios, loklok android, loklok for ios, loklok for android, loklok android tv, loklok chromecast, kdrama, k-drama, korean drama, box office, american movies, western movies, blockbuster movies, thailand movies, thai movies, TV drama, TV series, anime, animation, cartoon, variety show, yaoi, yuri, bl, gl, hollywood, bollywood, zombie, one piece, naruto, love affair, all of us are dead',
      description: 'Loklok is a one-stop video streaming platform for you to watch TV shows, movies, animation from all around the world! With wide variety of exclusive movies, you can choose multi-language subtitles and in ultra-HD 4k picture quality, popular new movies are released everyday!'
    },
    allPage: {
      title: 'Loklok Watch HD movies online for free, anything that you can imagine.',
      keywords: 'Loklok, Loklok app, loklok download, loklok pc, loklok apk,Watch online, Watch for Free, Watch dramas for free,  animation，anime，blockbuster movies，new episode，upcoming movies, 2022 new release，premiere，sci-fi，sweet romance，comedy，action，love, free movies, free movies online, free movies app, all of us are dead, F4 Thailand: Boys Over Flowers, Euphoria Season 2, Twenty five twenty one, Forecasting Love and Weather，Ghost Doctor, True Beauty，Encanto, From，Business Proposal，Snowdrop，Rookie Cops，Still 2gether',
      description: 'Loklok has a large number of popular movies and television content, and the latest and hottest TV series and movies are free to watch! Diversified high-definition content, personalized user experience, and popular movies are all here.'
    },
    articles: {
      title: 'Loklok Watch HD movies online for free, latest news',
      keywords: 'Loklok, Loklok app, loklok download, loklok pc, loklok apk,Watch online, Watch for Free, Watch dramas for free, latest movie and television information, movie recommendations, popular movie reviews, 2022 movie and television, movie premiere, 2022 worth watching, 2022 must watch, 2022 cinema movies, upcoming movies 2023, Peaky Blinders Season 6, attack on titan final season, our beloved summer, hotel transylvania 4: transformania, happiness',
      description: 'Loklok is Watch HD movies online for free, loklok get latest news, download loklok to watch global hit movies tv series for free'
    },
    download: {
      title: 'Lokok provides the latest official version download',
      keywords: 'Loklok, Loklok app, loklok download, loklok pc, loklok apk,Watch online, Watch for Free, Watch dramas for free, loklok download,download loklok,  loklok download apk, loklok ios download, loklok android download, loklok googleplay, loklok pc download, loklok latest version, loklok official website, how to download Loklok, Loklok desktop, Loklok pad',
      description: 'Download Loklok app, you can watch online the latest movies and TV series at home or on the go in extreme high-definition for free. Download the latest version of the Loklok app. After downloading and installing, scan the QR code of the website through the mobile phone, and start watching online at the same time on  your PC.'
    },
    search: {
      title: 'Loklok - Find Your Favorite Movies',
      keywords: 'Loklok, Loklok app, loklok download, loklok pc, loklok apk,Watch online, Watch for Free, Watch dramas for free, search dramas, search episodes, popular movie charts, box office charts, movie charts, TV series charts, movie ranking, korean drama ratings, thai drama ratings, top 10 movies, top 10 dramas, top 100 movies 2022, top 100 movies 2021, TOP 100 Most Anticipated 2022 Films, 2022 most watched movies, the best movies of 2021',
      description: 'Loklok recommends the most popular global popular dramas, movies, etc. according to the daily real-time update of total views and search popularity, to solve dramas shortage and improve watching experience.'
    },
    contact: {
      title: 'Contact us by E-mail, Twitter, Facebook, Instagram and Youtube. - Loklok',
      keywords: 'Twitter, Facebook, Instagram, Youtube, Contact, E-mail, Loklok',
      description: 'Questions about loklok can be communicated via email, Twitter, Facebook, Instagram and Youtube'
    }
  },
  globalTip: {
    emptyTip: 'Unable to locate resource',
    searchOther: 'Try searching for another movies or TV shows'
  },
  loginModule: {
    title: 'Login',
    loginMethod: 'Use loklok APP to scan the QR code',
    loginMethodTip: '(The version needs to be upgraded to 1.7.0 and above)',
    howToDownload: 'How to download loklok',
    clickMe: 'Click me',
    loginSuccess: 'Login successful',
    loginFailed: 'Login failed',
    codeExpired: 'The QR code has expired!',
    refreshButton: 'Refresh',
    loginButton: 'Login',
    loginTip: 'Watch all the contents for free after logging in',
    logoutButton: 'Logout',
    logoutTip: 'Enjoy the movie!',
    areYouSure: 'Are you sure you want to log out?',
    sure: 'Confirm',
    cancel: 'Cancel'
  },
  toTop: {
    downloadApp: 'Download App',
    backToTop: 'Back to top'
  },
  indexPage: {
    title: 'LolokTV',
    more: 'More',
    seeMore: 'See more'
  },
  searchPage: {
    resultTitle: 'Search Results:',
    rank: 'Most Popular on Loklok',
    play: 'Play',
    popularSearch: 'Top Search',
    top1: 'Top 1',
    top2: 'Top 2',
    top3: 'Top 3',
    top4: 'Top 4',
    top5: 'Top 5',
    top6: 'Top 6',
    top7: 'Top 7',
    top8: 'Top 8',
    top9: 'Top 9',
    top10: 'Top 10',
    emptyTip: 'Sorry, we don\'t have that content',
    emptyDesc: 'Try searching for another movie or drama'
  },
  filterPage: {
    emptyTip: 'Sorry, we don\'t have that content',
    emptyDesc: 'Try searching for another movie or drama'
  },
  newsPage: {
    listTitle: 'Latest news'
  },
  downloadPage: {
    scanQR: 'Scan QR code to download App',
    title1: 'Popular Movie&Drama',
    tip1: 'Watch it anytime for free',
    title2: 'Multilingual subtitles',
    tip2: 'Watch drama easily',
    title3: 'PC/Phone sync in real time'
  },
  detailPage: {
    autoTranslation: 'Automatic Translation',
    fiveMiniteTip: 'Only 5min, Watch the full movie after',
    loginTip2InDetailPage: 'Use the loklok APP to scan the QR code below to login, and then you can to view the rest of the content',
    category: 'Category',
    moreDesc: 'More',
    youMayLike: 'You may like',
    relatedSeries: 'Related series',
    norelatedSeries: 'No related series',
    emptyDesc: 'Sorry, we don\'t have that content',
    emptyTip: 'Sorry, we don\'t have that content',
    vip: {
      dialog: {
        t1: 'Activate VIP',
        t2: 'Activate VIP in the app to watch all contents',
        t3: 'Download the app via the method below',
        t4: 'Already have VIP? <span class="active">Click here</span> to login',
        t5: 'Already have VIP? Please <span class="active">refresh</span> and continue watching',
        t6: 'You have watched {num} minutes, if you want to continue watching the full movie, please use the app or activate VIP in the application and you can continue watching this movie.'
      },
      player: {
        tip1: 'You can only watch for {num} minutes. You can <span class="active">use the app</span> or <span class="active">activate VIP</span> to watch the whole video.'
      },
      episodes: {
        tip1: 'Get VIP & watch all contents'
      }
    }
  },
  playerModule: {
    NETWORK_LOADING: 'The browser is downloading data',
    NETWORK_NO_SOURCE: 'No audio/video source found',
    MEDIA_ERR_ABORTED: 'The retrieval process was aborted by the user',
    MEDIA_ERR_NETWORK: 'An error occurred while downloading',
    MEDIA_ERR_DECODE: 'Play parsing failed: unable to play file',
    MEDIA_ERR_SRC_NOT_SUPPORTED: 'Unsupported audio/video format',
    REPLAY: 'Replay',
    ERROR: 'There appears to be a problem with the network connection',
    PLAY_TIPS: 'Play',
    PAUSE_TIPS: 'Pause',
    PLAYNEXT_TIPS: 'Next episode',
    DOWNLOAD_TIPS: 'Download',
    ROTATE_TIPS: 'Rotate',
    RELOAD_TIPS: 'Reload',
    FULLSCREEN_TIPS: 'Enter full screen',
    EXITFULLSCREEN_TIPS: 'Exit full screen',
    CSSFULLSCREEN_TIPS: 'Enter style full screen',
    EXITCSSFULLSCREEN_TIPS: 'Exit style full screen',
    TEXTTRACK: 'Subtitles',
    PIP: 'Picture-in-picture',
    MINIPLAYER: 'mini player',
    SCREENSHOT: 'Screenshot',
    LIVE: 'Live streaming',
    OFF: 'Off',
    MINIPLAYER_DRAG: 'Click and hold to drag video',
    AIRPLAY_TIPS: 'AirPlay',
    onlyPlayTip: 'Only play {msg} minutes, {login} to watch the whole movie',
    loginTextButton: 'Login',
    replayButton: 'Replay',
    nextButton: 'Next episode',
    refreshButton: 'Refresh',
    episode: 'Episode',
    onlyPlayTextBtn: 'log in'
  },
  contact: {
    business: 'Business Cooperation',
    question: 'Questions&Feedback'
  },
  download_nd: {
    desc: 'Watch massive movies and TV dramas for free',
    scanQR: 'Scan QR code to download App or'
  },
  win: {
    feedback: {
      que: 'Frequently Asked Questions Explanation',
      que1: 'Frequently Asked Questions',
      content: 'Feedback Content',
      contact: 'Contact Information',
      submit: 'Send feedback',
      tip1: 'Please provide a detailed description, and you may also include relevant screenshots.',
      tip2: 'Please enter your email.',
      tip5: 'The uploaded image size must be less than {num}k.',
      tip6: 'A maximum of 4 images can be uploaded.',
      tip3: 'Submitted, please be patient.',
      tip4: 'The feedback content must be no less than 10 words.',
      error: 'System Error'
    }
  },
  tv: {
    vip: {
      title: 'Please select your product',
      tip1: 'You can view the payment QR code after logging in.',
      refresh: 'Refresh',
      tip2: 'Scan the QR code to payment',
      recharge: 'Recharge Agreement',
      renewal: 'Renewal Agreement',
      login: 'Log in now',
      tip3: 'View after logging in',
      noOpen: 'Standard VIP Not Activated',
      gift: 'Gift',
      succ: 'Refresh successful',
      fail: 'Refresh failed',
      day: 'Standard VIP 1 Day',
      days: 'Standard VIP {x} Days',
      expiration: 'Standrad VIP expiration time：{x}',
      expired: 'Your VIP has expired, please renew it promptly.',
      interests1: 'Enjoy 1080P HD quality',
      interests2: 'Unlock all content',
      interests3: 'Multi-device login'
    }
  }
}